import { action } from 'satcheljs';

/**
 * Saves the event
 */
export let saveEvent = action('saveEvent', (formId: string) => ({
    formId,
}));

/**
 * Saves the event draft
 */
export const saveEventDraft = action(
    'saveEventDraft',
    (formId: string, shouldForceCloseOnSend?: boolean) => ({
        formId,
        shouldForceCloseOnSend,
    })
);

/**
 * Checks properties then saves the event
 */
export let verifyEventThenSave = action(
    'verifyEventThenSave',
    (formId: string, targetWindow?: Window) => ({
        formId,
        targetWindow,
    })
);

/**
 * Prepares the event for the save
 */
export let prepareEvent = action('prepareEvent', (formId: string) => ({
    formId,
}));

/**
 * Resets the compose form and related stores
 */
export let resetComposeStore = action('resetComposeStore', (formId: string) => ({
    formId,
}));

export const saveAndSendDraft = action('saveAndSendDraft', (formId: string) => ({
    formId,
}));
